import { Component, OnInit } from '@angular/core';
import { SidebarComponent } from './sidebar/sidebar.component';
import { NavbarPanelComponent } from './navbar/navbar.component';
import { ClientesComponent } from './clientes/clientes.component';
import { CommonModule } from '@angular/common';
import { LicencasComponent } from './licencas/licencas.component';
import { RevendedoresComponent } from './revendedores/revendedores.component';
import { AuthServiceService } from './services/auth-service.service';
import { Router } from '@angular/router';
import { ConfiguracoesComponent } from './configuracoes/configuracoes.component';
import { WebhooksComponent } from "./webhooks/webhooks.component";
@Component({
  selector: 'app-paneladmin',
  standalone: true,
  imports: [SidebarComponent, NavbarPanelComponent, ClientesComponent, CommonModule, LicencasComponent, RevendedoresComponent, ConfiguracoesComponent, WebhooksComponent],
  templateUrl: './paneladmin.component.html',
  styleUrls: ['./paneladmin.component.scss'],
  providers: [AuthServiceService]
})


export class PaneladminComponent  {
  public itemSelecionado: string = 'clientes';
  public menuOpen: boolean = false;
  constructor(private authService: AuthServiceService, private router: Router) { }

  ngOnInit() {
    this.authService.requestDataPeriodicallyAdmin().subscribe(()=> {
      console.log('Rodando requisicao de autenticacao periodica');
    },(error: any)=> {
      this.router.navigate(['/admin']);
    }) 
  }

  public async mostrarItemSelecionado(item: string){
    this.itemSelecionado = item;
  }

  public async setStatusMenu(status: boolean) {
    this.menuOpen = status;
  }

  
}
